/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * GeoStrat API
 * Geopolitical strategy game simulation API - manage nations, diplomacy, trade, and military operations
 * OpenAPI spec version: 1.0.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  Notif
} from '.././models';

import { customInstance } from '.././custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const userNotifsRetrieve = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<Notif>(
      {url: `/all/user-notifs/`, method: 'GET', signal
    },
      options);
    }
  



export const getUserNotifsRetrieveQueryKey = () => {
    return [
    `/all/user-notifs/`
    ] as const;
    }

    
export const getUserNotifsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof userNotifsRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userNotifsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserNotifsRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userNotifsRetrieve>>> = ({ signal }) => userNotifsRetrieve(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userNotifsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserNotifsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof userNotifsRetrieve>>>
export type UserNotifsRetrieveQueryError = unknown


export function useUserNotifsRetrieve<TData = Awaited<ReturnType<typeof userNotifsRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userNotifsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userNotifsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof userNotifsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserNotifsRetrieve<TData = Awaited<ReturnType<typeof userNotifsRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userNotifsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userNotifsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof userNotifsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserNotifsRetrieve<TData = Awaited<ReturnType<typeof userNotifsRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userNotifsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUserNotifsRetrieve<TData = Awaited<ReturnType<typeof userNotifsRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userNotifsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserNotifsRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




